// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-common-btn {
    width: auto;
    /* margin-left: -15px; */
}

.generate-img {
    width: 100%;
    height: 400px;
    border: 1px solid #e7e7e7;
    border-radius: 10px;
    padding: 10px;
}

.generate-img img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/ai-generate-image/ai-generate-image.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".video-common-btn {\n    width: auto;\n    /* margin-left: -15px; */\n}\n\n.generate-img {\n    width: 100%;\n    height: 400px;\n    border: 1px solid #e7e7e7;\n    border-radius: 10px;\n    padding: 10px;\n}\n\n.generate-img img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
